/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLabelImportantFilled = createReactComponent("filled", "label-important-filled", "IconLabelImportantFilled", [["path", { "d": "M16.52 6a2 2 0 0 1 1.561 .75l3.7 4.625a1 1 0 0 1 0 1.25l-3.7 4.624a2 2 0 0 1 -1.561 .751h-12.52a1 1 0 0 1 -.78 -1.625l3.5 -4.375l-3.5 -4.375a1 1 0 0 1 .668 -1.62l.112 -.005z", "key": "svg-0" }]]);

export { IconLabelImportantFilled as default };
//# sourceMappingURL=IconLabelImportantFilled.mjs.map
